import { popoverAnatomy } from '@chakra-ui/react/anatomy';
import { defineSlotRecipe } from '@chakra-ui/react/styled-system';

import { rem } from '../themeUtils';

const popoverSlotRecipe = defineSlotRecipe({
  className: 'popover',
  slots: [...popoverAnatomy.keys(), 'scrollBody', 'scrollButton', 'scrollGradient'] as const,
  base: {
    content: {
      background: 'background/primary',
      borderRadius: '8',
      boxShadow: 'elevation/lg',
      display: 'flex',
      flexDirection: 'column',
      maxHeight: '60vh',
      outline: 'none',
      overflow: 'hidden',
      position: 'relative',
      transformOrigin: 'var(--transform-origin)',
      width: rem(360),
      zIndex: 'popover',
      _open: {
        animationStyle: 'scale-fade-in',
        animationDuration: 'fast',
      },
      _closed: {
        animationStyle: 'scale-fade-out',
        animationDuration: 'faster',
      },
    },
    header: {
      alignItems: 'flex-start',
      display: 'flex',
      flexShrink: 0,
      gap: '8',
      paddingBlockEnd: '8',
      paddingBlockStart: '16',
      paddingInline: '16',
    },
    title: {
      color: 'text/primary',
      flex: '1',
      minWidth: 0,
      textStyle: 'heading/h4',
      wordBreak: 'break-word',
    },
    closeTrigger: {
      flexShrink: 0,
    },
    scrollBody: {
      display: 'flex',
      flex: '1',
      flexDirection: 'column',
      minHeight: 0,
      position: 'relative',
    },
    body: {
      flex: '1',
      minHeight: 0,
      overflowY: 'auto',
      paddingBlockEnd: '16',
      paddingBlockStart: '8',
      paddingInline: '16',
    },
    footer: {
      alignItems: 'center',
      display: 'flex',
      flexShrink: 0,
      gap: '8',
      justifyContent: 'space-between',
      paddingBlockEnd: '16',
      paddingBlockStart: '24',
      paddingInline: '16',
    },
    scrollGradient: {
      background: 'linear-gradient(0deg, {colors.neutral.100} 0%, transparent 100%)',
      bottom: 0,
      height: '32',
      pointerEvents: 'none',
      position: 'absolute',
      width: '100%',
    },
    scrollButton: {
      alignItems: 'center',
      alignSelf: 'center',
      background: 'background/primary',
      borderColor: 'border/minimal',
      borderRadius: 'full',
      borderWidth: '1',
      bottom: '8',
      boxShadow: 'elevation/lg',
      cursor: 'pointer',
      display: 'flex',
      height: '32',
      justifyContent: 'center',
      position: 'absolute',
      width: '32',
    },
  },
});

export default popoverSlotRecipe;
